<template>
	<div class="ud_wrap" v-show="updata.title">
		<div class="up_dowm" v-if="!isPhone">
			<div class="ud_left">
				<div class="ud_box">
					<span>上一篇</span>
					<span></span>
					<span @click="toNextArticle(updata.id)" :class="updata.id?'hover_sty':''">{{ updata.title }}</span>
				</div>
				<div class="ud_box" style="margin-top: 20px;">
					<span>下一篇</span>
					<span></span>
					<span @click="toNextArticle(nextdata.id)" :class="nextdata.id?'hover_sty':''">{{ nextdata.title }}</span>
				</div>
			</div>
			<div class="ud_right" @click="fanHui">返回列表</div>
		</div>
		<div class="up_dowm2" v-if="isPhone">
			<div class="ud_box">
				<span>上一篇</span>
				<span></span>
				<span class="ellip" @click="toNextArticle(updata.id)">{{ updata.title }}</span>
			</div>
			<div class="ud_box">
				<span>下一篇</span>
				<span></span>
				<span class="ellip" @click="toNextArticle(nextdata.id)">{{ nextdata.title }}</span>
			</div>
			<div class="ud_right">
				<span @click="fanHui">返回列表</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		updata: {
			type: Object,
			required: true,
		},
		nextdata: {
			type: Object,
			required: true,
		},
		atpage: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			isPhone: this.$isMobile,
		}
	},
	methods: {
		toNextArticle(id) {
			if (this.atpage == 'infodisclo' && id) {
				this.$router.replace("/infoDisclosure/infoDetail?id=" + id + "&sort=" + this.$route.query.sort);
			}
			if (this.atpage == 'partybuilding' && id) {
				this.$router.replace("/partyBuilding/partyDetail?id=" + id + "&sort=" + this.$route.query.sort);
			}
			if (this.atpage == 'news' && id) {
				this.$router.replace("/news/newsDetail?id=" + id + "&sort=" + this.$route.query.sort);
			}
            if (this.atpage == 'jobdetail' && id) {
				this.$router.replace("/joinUs/jobDetail?id=" + id);
			}
		},
		fanHui() {
			if (this.atpage == 'infodisclo') {
				this.$router.replace("/infoDisclosure/infoList?sort=" + this.$route.query.sort);
			}
			if (this.atpage == 'partybuilding') {
				if (this.$route.query.sort2) {
					this.$router.replace("/partyBuilding/partyList?sort=" + this.$route.query.sort + '&sort2=' + this.$route.query.sort2);
				} else {
					this.$router.replace("/partyBuilding/partyList?sort=" + this.$route.query.sort);
				}
			}
			if (this.atpage == 'news') {
				this.$router.replace("/news/newsList?sort=" + this.$route.query.sort);
			}
            if (this.atpage == 'jobdetail') {
				this.$router.replace("/joinUs/jobBoard");
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.hover_sty {
	cursor: pointer;
	&:hover {
		color: #004098 !important;
	}
}
.ud_wrap {
	.up_dowm {
		border-top: 1px solid #ddd;
		margin-top: 30px;
		padding-top: 30px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.ud_left {
			flex: 1;
			.ud_box {
				display: flex;
				align-items: center;
				span {
					font-size: 16px;
					color: #444;
					&:nth-child(2) {
						width: 1px;
						height: 15px;
						background-color: #999;
						margin: 0 10px;
					}
					&:nth-child(3) {
						flex: 1;
					}
				}
			}
		}
		.ud_right {
			width: 110px;
			border-radius: 8px;
			border: 1px solid #d9d9d9;
			font-size: 16px;
			height: 38px;
			line-height: 38px;
			text-align: center;
			cursor: pointer;
			margin-left: 20px;
		}
	}
	.up_dowm2 {
		border-top: 1px solid #ddd;
		padding-top: 0.1rem;
		margin: 0.3rem 0.35rem 0.8rem 0.3rem;
		.ud_box {
			margin-top: 0.4rem;
			display: flex;
			align-items: center;
			span {
				font-size: 16px;
				color: #444;
				&:nth-child(2) {
					width: 1px;
					height: 0.35rem;
					background-color: #999;
					margin: 0 0.25rem;
				}
				&:nth-child(3) {
					flex: 1;
				}
			}
		}
		.ud_right {
			display: flex;
			justify-content: center;
			align-items: center;
            margin-top: 0.5rem;
			span {
				background-color: #004098;
                color: #fff;
				font-size: 16px;
				width: 120px;
				border-radius: 8px;
                display: inline-block;
                text-align: center;
                padding: 0.25rem;
			}
		}
	}
}
</style>